import _ from 'lodash'

export const deleteDialogMixin = {
  data () {
    return {
      deleteData: null,
      deleteDialog: false,
      deleteChecked: false,
      deleteFormValidation: false
    }
  },
  methods: {
    openDeleteDialog (item) {
      this.deleteData = _.cloneDeep(item)
      this.deleteDialog = true
    },
    executeDelete (callback) {
      if (!this.$refs.form.validate()) {
        return
      }
      this.deleteDialog = false
      this.deleteChecked = false
      if (typeof callback === 'function') {
        return callback()
      } else {
        console.log('not a function')
      }
    },
    cancelDeleteDialog (callback) {
      this.deleteDialog = false
      this.$refs.form.reset()
      if (typeof callback === 'function') {
        return callback()
      } else {
        console.log('not a function')
      }
    }
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/mixins/deleteDialogMixin.js